import React from 'react';
import { Helmet } from 'react-helmet-async';
import AboutSection from '../components/home/AboutSection';
import InstructorsSection from '../components/home/InstructorsSection';
import ScheduleSection from '../components/home/ScheduleSection';
import ContactSection from '../components/home/ContactSection';
import { useLanguage } from '../contexts/LanguageContext';
import { rotterdamStructuredData } from '../data/rotterdamStructuredData';
import '../styles/Home.css';

const Home = () => {
  const { language } = useLanguage();

  const metaContent = {
    en: {
      title: 'Team Agua BJJ Rotterdam - Brazilian Jiu-Jitsu Training',
      description: 'Train Brazilian Jiu-Jitsu in Rotterdam with Team Agua BJJ. Expert instructors, flexible schedules, and welcoming community for all skill levels.'
    },
    nl: {
      title: 'Team Agua BJJ Rotterdam - Brazilian Jiu-Jitsu Training',
      description: 'Train Brazilian Jiu-Jitsu in Rotterdam bij Team Agua BJJ. Ervaren instructeurs, flexibele roosters en gastvrije gemeenschap voor alle niveaus.'
    }
  };

  const content = metaContent[language] || metaContent.en;

  return (
    <div className="home-page">
      <Helmet>
        <title>{content.title}</title>
        <meta name="description" content={content.description} />
        <link rel="canonical" href="https://rotterdam.aguabjj.nl/" />
        <link rel="preload" as="image" href="/images/optimized/team-agua-gi-1280.webp" fetchpriority="high" />
        <script type="application/ld+json">
          {JSON.stringify(rotterdamStructuredData)}
        </script>
        
        {/* Open Graph */}
        <meta property="og:title" content={content.title} />
        <meta property="og:description" content={content.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rotterdam.aguabjj.nl/" />
        <meta property="og:image" content="https://rotterdam.aguabjj.nl/images/team-agua-500.png" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={content.title} />
        <meta name="twitter:description" content={content.description} />
        <meta name="twitter:image" content="https://rotterdam.aguabjj.nl/images/team-agua-500.png" />
      </Helmet>

      <AboutSection />
      <ScheduleSection />
      <InstructorsSection />
      <ContactSection />
    </div>
  );
};

export default Home;
